import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricCpc extends MetricBase {
    constructor() {
        super({
            field: "metric_cpc",
            defaultVisibility: false,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.tripadvisor.cpc.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.cpc.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.cpc.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCpc;
